<template>
  <div class="icp">
    {{ `© ${year} ${author} `
    }}<a href="http://beian.miit.gov.cn/" target="_blank">{{ record }}</a>
  </div>
</template>

<script setup lang="ts">
const getRecord = () => {
  let host = window.location.hostname.split('.').slice(-2).join('.');
  let defaultRecord = '粤ICP备2024246993号';
  let recordMap:Map<string,string> = new Map();
  recordMap.set("zgzhongyi.com", "粤ICP备2024246993号-2");
  recordMap.set("chuimohangye.com", "粤ICP备2024246993号-1");
  recordMap.set("zgzhongyi.cn", "粤ICP备2024246993号-3");
  console.log("host", host)
  let record_temp = recordMap.get(host);
  console.log("record", record_temp)
  if (!record_temp) {
    return defaultRecord;
  } else {
    return record_temp;
  }
}
let year = new Date().getFullYear(); // 一般都是最新的一年
let author = "众毅科技"; // 作者名
let record = getRecord(); // 备案号
</script>

<style>
.icp {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 10px 0;
  width: 100%;
  height: 36px;
  white-space: pre;
  text-align: center;
  color: gray;
  z-index: 1000;
}
.icp > a {
  color: gray;
  text-decoration: none;
}
.icp > a:hover {
  color: aqua;
  text-decoration: none;
}
</style>
